export const DEVICE_GROUPS_PAGE_NAME = 'device-groups';
